"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "input-number-range"
  }, [_c("div", {
    staticClass: "input-number-range-control",
    class: {
      disabled: _vm.disabled
    }
  }, [_c("a-input-number", _vm._b({
    attrs: {
      placeholder: _vm.placeholder[0]
    },
    on: {
      change: function ($event) {
        return _vm.handleChange($event, "min");
      }
    },
    model: {
      value: _vm.value[0],
      callback: function ($$v) {
        _vm.$set(_vm.value, 0, $$v);
      },
      expression: "value[0]"
    }
  }, "a-input-number", _vm.$props, false)), _c("span", {
    staticClass: "input-number-range-separator"
  }, [_vm._v("至")]), _c("a-input-number", _vm._b({
    attrs: {
      placeholder: _vm.placeholder[1]
    },
    on: {
      change: function ($event) {
        return _vm.handleChange($event, "max");
      }
    },
    model: {
      value: _vm.value[1],
      callback: function ($$v) {
        _vm.$set(_vm.value, 1, $$v);
      },
      expression: "value[1]"
    }
  }, "a-input-number", _vm.$props, false))], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;